/* eslint-env browser, jquery */
/* globals CountdownTimer, _ */

'use strict';

require('../../groupon-deal-timer/responsive/common/helpers');
require('../../groupon-deal-timer/responsive/frontend/models/countdown_timer');
require('../../groupon-deal-timer/responsive/frontend/views/countdown_timer');
require('../../groupon-deal-timer/responsive/frontend/countdown_timer');

const StickyHandler = require('../../sticky_handler/frontend');

const DealHighlights =
  window.DealHighlights != null
    ? window.DealHighlights
    : (window.DealHighlights = {});

const ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000;
const PRIMARY_MESSAGE_TIMEOUT_TOUCH = 3000;

DealHighlights.fixWidthData = {};
DealHighlights.fixWidth = (timerData, isSticky = false) => {
  if (timerData.isTouchRequest) {
    const MAX_TIMESTAMP_WIDTH = isSticky ? 57 : 62;

    // get current widths
    const containerWidth = $('.deal-highlights .urgency.columns .text').width();
    const textWidth = $(
      '.deal-highlights .urgency.columns .text .countdown-text'
    ).outerWidth(true);

    const $timestamp = $(
      '.deal-highlights .urgency.columns .text .countdown-timestamp'
    );
    const $timer = $(
      '.deal-highlights .urgency.columns .text .countdown-timer'
    );

    const hasDays = timerData.timeLeft.days > 0;
    if (hasDays) {
      $timer.addClass('with-days');
    }

    if (!DealHighlights.fixWidthData.daysWidth) {
      const timerWidth = $timer.width();
      const timestampWidth = $timestamp.width();
      DealHighlights.fixWidthData.daysWidth = timerWidth - timestampWidth;
    }

    const availableSpace = containerWidth - textWidth;
    const neededSpace = hasDays
      ? MAX_TIMESTAMP_WIDTH + DealHighlights.fixWidthData.daysWidth
      : MAX_TIMESTAMP_WIDTH;

    let fixingClass = '';
    if (availableSpace < neededSpace) {
      fixingClass += ' two-lines';
    }

    if (
      hasDays &&
      (containerWidth < neededSpace ||
        $timestamp.height() + 2 < $timer.height())
    ) {
      fixingClass += ' three-lines';
    }

    $timer.removeClass('two-lines three-lines').addClass(fixingClass);
  }
};

DealHighlights.rotateMessages = (messagesContainer, loopMessages = false) => {
  let currentMessage = messagesContainer.find('.primary');
  let nextMessage = messagesContainer.find('.secondary');

  const switchMessage = () => {
    currentMessage.addClass('fade-out').removeClass('fade-in');
    nextMessage.addClass('fade-in').removeClass('fade-out');
    if (loopMessages) {
      const ref = currentMessage;
      currentMessage = nextMessage;
      nextMessage = ref;
    }
  };

  if (loopMessages) {
    return window.setInterval(
      switchMessage,
      PRIMARY_MESSAGE_TIMEOUT_TOUCH + ACTIVATE_PRIMARY_MESSAGE_TIMEOUT
    );
  }
  return window.setTimeout(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH);
};

DealHighlights.init = ({ dealHighlights }, done) => {
  if (!dealHighlights) {
    return;
  }

  let { tiles } = dealHighlights;
  if (
    dealHighlights.leftTile ||
    dealHighlights.middleTile ||
    dealHighlights.rightTile
  ) {
    tiles = [
      dealHighlights.leftTile,
      dealHighlights.middleTile,
      dealHighlights.rightTile,
    ].filter(a => a);
  }

  const activateRotatingMessaging = function activateRotatingMessaging(
    $element,
    loopMessages
  ) {
    if ($element.attr('data-activated') === 'true') {
      return;
    }
    $element.attr('data-activated', 'true');
    DealHighlights.rotateMessages($element, loopMessages);
  };

  const scrollHandler = function scrollHandler(e, $element, loopMessages) {
    if ($(this).scrollTop() > 0) {
      $(this).off(e);
      activateRotatingMessaging($element, loopMessages);
    }
  };

  const bindHighlightLinksNavigation = function bindHighlightLinksNavigation(
    id
  ) {
    const $anchorElement = $(`.deal-highlights a[href="#${id}"]`);

    return window.TouchDeal != null
      ? window.TouchDeal.bindTargetNavigation($anchorElement)
      : undefined;
  };

  const prepareWindowHandlers = function prepareWindowHandlers(
    $element,
    timeout = ACTIVATE_PRIMARY_MESSAGE_TIMEOUT,
    loopMessages
  ) {
    window.setTimeout(
      () => activateRotatingMessaging($element, loopMessages),
      timeout
    );

    return $(window).on('scroll', e =>
      scrollHandler(e, $element, loopMessages)
    );
  };

  let timerData;
  for (let i = 0; i < tiles.length; i += 1) {
    const tile = tiles[i];
    if (tile.secondaryMessage) {
      const messageTimer = tile.messageTimerInSec * 1000;
      const loopMessages = tile.loop === true;
      prepareWindowHandlers(
        $(
          '.t-main-inner .deal-highlights, #purchase-cluster .deal-highlights, .multi-option-overlay-cluster .deal-highlights'
        ),
        messageTimer,
        loopMessages
      );

      if ($('#options-pane .deal-highlights').length) {
        window.UrlHashChange.eventBus.board('showHideOptions', () =>
          prepareWindowHandlers(
            $('#options-pane .deal-highlights'),
            ACTIVATE_PRIMARY_MESSAGE_TIMEOUT,
            loopMessages
          )
        );
      }
    } else if (tile.jsTimerData) {
      timerData = _.extend(tile.jsTimerData, {
        el: '.deal-highlights .countdown-timer',
        translationScope: 'js.modules.groupon-deal-timer.tile',
      });

      CountdownTimer.init({ timerData });
      DealHighlights.fixWidth(timerData);
    }
  }

  bindHighlightLinksNavigation('touch-tips');

  if (dealHighlights.tilesMeta && dealHighlights.tilesMeta.isStickyUMS) {
    const options = {
      $element: $('.t-main .deal-highlights.sticky-ums'),
      $wrapper: $('.t-main .deal-highlights-wrapper'),
    };
    if (timerData !== undefined) {
      options.onStateChange = () => {
        $('.t-main .deal-highlights.sticky-ums')[0].addEventListener(
          'transitionend',
          DealHighlights.fixWidth.bind(null, timerData, true),
          {
            once: true,
          }
        );
      };
    }

    DealHighlights.stickyHandler = new StickyHandler(options);
  }
  done();
};

module.exports = DealHighlights;



// WEBPACK FOOTER //
// ./modules/deal_highlights/frontend/deal_highlights.js